<template>
<div class="article page-container" :class="[fields.template, fields.uid]">
  <!-- Main -->
  <main :class="['main', fields.uid, fields.template]">
    <!-- Breadcrumbs -->
    <aside class="breadcrumb text-bold text-extended" style="opacity: 1;">
      <span class="page-title">{{ fields.title }}</span>
      <span id="section-title" class="section-title"></span>
    </aside>
    
    <!-- Ticker -->

    <div class="ticker bg-pink loaded" data-title="Magazine">
        <div>
            <marquee-text :duration="60">
              <h3 class="ticker-item fs-normal">Magazine</h3>
              <span class="ticker-item performa fs-normal">Performa</span>
              <span class="ticker-item fs-normal">Magazine</span>
              <span class="ticker-item performa fs-normal">Performa</span>
            </marquee-text>
        </div>
    </div>
        <div class="relative">
        <figure @click="showPhotoSwipe(0)" class="featured-image"  :class="fields.desktop_featured_image_crop_point">
          <prismic-image :field="fields.featured_image"/>
          <figcaption><prismic-rich-text :field="fields.featured_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
        </figure>
  
      
    <section class="page-content">
      <header>
	      <span v-if="tags.includes('reports')" class="text-uppercase text-condensed">Performa Reports</span>
	      <span v-if="tags.includes('in-conversation')" class="text-uppercase text-condensed">In Conversation</span>
	      <span v-if="tags.includes('features')" class="text-uppercase text-condensed">Features</span>
	      <span v-if="tags.includes('essays')" class="text-uppercase text-condensed">Essays</span>
        <h1 class="text-bold text-extended">{{ fields.title }}</h1>
        <p class="excerpt" style="text-indent: 0px;">{{ fields.subtitle }}</p>
        <hr/>
      </header>
      

      <template v-for="(slice, index) in slices">
        <template v-if="slice.slice_type === 'title'">
          <article class="breadcrumb-trigger" :data-title="slice.primary.section_title">
          <h2 class="text-condensed text-uppercase text-left"><strong>{{ slice.primary.section_title }}</strong></h2>
          </article>
        </template>
        <template v-if="slice.slice_type === 'text'">
          <article class="text">
	          
          <prismic-rich-text v-if="slice.primary.section_text != null" :field="slice.primary.section_text" :class="slice.primary.section_text_class"/>
          
          <div v-if="slice.primary.imported_text[0] != null" class="slice.primary.section_text_class" v-html="slice.primary.imported_text[0].text" />
          
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'image'">
          <article>
					    <figure class="img img-landscape" @click="showPhotoSwipe(index)">
              	<img :src="slice.primary.section_image.url" />
              	<span>{{ index }}</span>
								<figcaption><prismic-rich-text :field="slice.primary.section_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
          		</figure>   
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'carousel'">
          <carousel paginationColor="#ffffff" :paginationSize="8" :paginationPadding="4">
            <slide v-for="(item, index) in slice.items" class="carousel-slide" :key="item.id">
              <figure class="img">
              <picture>
                <!-- <source :srcset="item.slide_image.mobile.url" media="(max-width: 769px)"> -->
                <img :src="item.slide_image.url">
              </picture>
              <figcaption><prismic-rich-text :field="item.slide_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
              </figure>
            </slide>
          </carousel>
        </template>
        <template v-else-if="slice.slice_type === 'image_grid'">
          <div class="grid-container c3 image-grid">
            <div v-for="(item, index) in slice.items" class="grid-image">
              <figure class="img img-landscape">
                <img v-lazy="item.grid_image.url">
              <figcaption><prismic-rich-text :field="item.grid_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
              </figure>
            </div>
          </div>
        </template>
        <template v-else-if="slice.slice_type === 'cta'">
          <article>
            <template v-for="(item, index) in slice.items">
              <prismic-link :field="item.cta_link" class="cta btn btn--inline">
              <span>{{ item.cta_text }}</span>
              </prismic-link>
            </template>
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'video'">
          <article class="article-video">
          <figure class="img">              
          <div class="rb-video-wrap video-wrap muted">
            <video id="rb-video" playsinline="" autoplay="" loop="" muted="true" preload="auto">
              <source :src="slice.primary.video_link.url" type="video/mp4">
            </video>
          </div>
          <figcaption><prismic-rich-text :field="slice.primary.video_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
          </figure>
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'image_banner'">
          <figure class="img">
            <img v-lazy="slice.primary.banner_image.url" />
            <figcaption><prismic-rich-text :field="slice.primary.banner_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
          </figure>
        </template>
        <template v-else-if="slice.slice_type === 'horizontal_break'">
          <article>
          <hr>
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'pull_quote'">
          <article>
            <aside class="pquote">
            <blockquote>
              <prismic-rich-text :field="slice.primary.quote_text" :htmlSerializer="innerSingleParagraph"/>
            </blockquote>
            <template v-if="slice.primary.quote_author">
            <prismic-rich-text :field="slice.primary.quote_author" :htmlSerializer="innerSingleParagraph" class="pquote-author"/>
            </template>
            </aside>
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'expander'">
          <article>
          <ul class="grid-list text-smaller">
            <li v-for="(item, index) in slice.items" class="staff-expand-header expand-header" v-on:click="expandIt">
              <div class="grid-container c2">
                <span class="staff-position text-smaller text-condensed text-uppercase">{{ item.item_subtitle }}</span>
                <span class="staff-name text-right text-bold">{{ item.item_title }}</span>
              </div>
              <prismic-rich-text :field="item.item_description" class="expander" />
            </li>
          </ul>
          </article>
        </template>
        
      </template>
		    
	    <v-photoswipe :isOpen="isOpen" :items="items" :options="options" @close="hidePhotoSwipe"></v-photoswipe>

    </section>
</div>
  </main>
  <prismic-edit-button :documentId="documentId"/>
</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import prismicDOM from 'prismic-dom';

import { PhotoSwipe, PhotoSwipeGallery } from 'v-photoswipe';

 
const Elements = prismicDOM.RichText.Elements;
  
const innerSingleParagraph = function (type, element, content, children) {
  if (type === Elements.paragraph) {
    return `${children.join('')}`;
  }
  return null;
}

const toggleClass = function (target, addRemoveClass, className) {
  if (addRemoveClass === 'addClass') {
    target.classList.add(className);
  } else {
    target.classList.remove(className);
  }
}

export default {
  name: 'Article',
  data () {
    return {
      innerSingleParagraph,
      documentId: '',
      fields: {
        uid: null,
        title: null,
        date: null,
        description: null,
        template: null,
        featured_image: null,
        featured_image_caption: null,
        desktop_featured_image_crop_point: null
      },
      slices: [],
      tags: [],
      tickers: [],
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0,
        showHideOpacity: true,
        history: false
      },
      optionsGallery: {},
      items: []
    }
  },
  components: {
    Carousel,
    Slide,
    'v-photoswipe': PhotoSwipe,
    'v-photoswipe-gallery': PhotoSwipeGallery
  },
  metaInfo () {
	  
	  if (this.fields.description == null) {
		  var description = 'Founded by RoseLee Goldberg in 2004, Performa is the leading organization dedicated to exploring the critical role of live performance in the history of twentieth-century art and to encouraging new directions in performance for the twenty-first century.';
	  } else {
		  	  var description = this.fields.description;
	  }
	  
    return {
      title: this.fields.title,
      meta: [
		    {vmid: 'description', name: 'description', content: description},
		     
		    {vmid: 'og:title', property: 'og:title', content: this.fields.title},
		    {vmid: 'og:site_name', property: 'og:site_name', content: 'Performa'},
		    {vmid:'og:type', property: 'og:type', content: 'article'},
		    // Should be the the same as your canonical link, see below.
		    {vmid:'og:url', property: 'og:url', content: 'https://performa-arts.org/magazine/' + this.fields.uid},
		    // Often the same as your meta description, but not always.
		    {vmid:'og:description', property: 'og:description', content: description},
		    {vmid:'og:image', property: 'og:image', content: this.fields.featured_image_url},
		    
		
		    {vmid: 'twitter:card', name: 'twitter:card', content: 'summary'},
		    {vmid: 'twitter:site', name: 'twitter:site', content: 'https://performa-arts.org/magazine/' + this.fields.uid},
		    {vmid: 'twitter:title', name: 'twitter:title', content: this.fields.title + ' - Performa'},
		    {vmid: 'twitter:description', name: 'twitter:description', content: description},
		    {vmid: 'twitter:creator', name: 'twitter:creator', content: '@PerformaNYC'},
		    {vmid: 'twitter:image', name: 'twitter:image', content: this.fields.featured_image_url},
		
		    {vmid: 'itemprop-name', itemprop: 'name', content: this.fields.title + ' - Performa'},
		    {vmid: 'itemprop-description', itemprop: 'description', content: description},
		  ]
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getByUID('article', uid)
        .then((document) => {
          if (document) {
            this.documentId = document.id
            this.fields.uid = document.uid
            this.fields.title = document.data.title
            this.fields.subtitle = document.data.subtitle
            this.fields.date = document.data.date
            this.fields.description = document.data.seo_description
            this.fields.template = document.data.template
            this.fields.featured_image = document.data.featured_image
            this.fields.featured_image_url = document.data.featured_image.url
            this.fields.featured_image_caption = document.data.featured_image_caption
            this.fields.desktop_featured_image_crop_point = document.data.desktop_featured_image_crop_point
            this.slices = document.data.body
            this.tags = document.tags
            this.tickers = document.data.body1
            this.items.push({
		          src: document.data.featured_image.url,
		          w: document.data.featured_image.dimensions.width,
		          h: document.data.featured_image.dimensions.height,
		          title: prismicDOM.RichText.asHtml(document.data.featured_image_caption, innerSingleParagraph),
		          index: 0
		        })
            
            for (var [i, slice] of this.slices.entries()) {
	            
						  if (slice.slice_type == 'image') {
							  this.items.push({
				          src: slice.primary.section_image.url,
				          w: slice.primary.section_image.dimensions.width,
				          h: slice.primary.section_image.dimensions.height,
				          title: prismicDOM.RichText.asHtml(slice.primary.section_image_caption, innerSingleParagraph),
				          index: i
				        })
						  }
						}
						
            } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    },
    expandIt() {
          toggleClass(this, 'addClass', 'loaded');
    },
    showPhotoSwipe (index) {
      this.isOpen = true
      this.$set(this.options, 'index', index)
    },
    hidePhotoSwipe () {
      this.isOpen = false
    }
  },
  created () {
    this.getContent(this.$route.params.articleId);
  },
  mounted() {
    setTimeout(function() {
      toggleClass(document.body, 'addClass', 'loaded')			
    }, 500);
  },
  destroyed() {
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.articleId)
    next()
  },
  beforeDestroy() {
    this.items = []
	}
}
</script>

<style>
	
figure {
	cursor: pointer;
}
	
.pswp__caption__center {
	color: $tru-white !important;
	line-height: 1 !important;
	max-width: 50% !important;
	font-size: 12px !important;
	pointer-events: none !important;
}

.pswp__top-bar {
	display: none;
}

.text .underlined, .expander .underlined {
  font-family: "Lars Sans Condensed", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
  border-bottom: 1px #000000 solid;
  font-size: 0.85em;
}
video {
  max-width: 100%;
}
</style>